import { Component, OnInit,Input,HostListener,ViewChild,ElementRef } from '@angular/core';
import {commonService} from "../../service/common.service";
import {ForumsService} from "../../service/forums.service";
import {HttpErrorResponse } from '@angular/common/http';
import {Globals } from '../../globals';
import { TestSeriesService } from '../../service/test-series.service';
import { send } from 'q';
import { Router,ActivatedRoute } from '@angular/router';
import {FormControl, NgForm} from '@angular/forms';


@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css'],
  providers:[TestSeriesService]
})
export class TimelineComponent implements OnInit {
  userData:any;
  testData:any;
  testDataCount:any;
  path:any;
  isSuccess=false;
  msg:any;
  isPostLoad=true;
  searchstatus:any;
  serchtext:any;
  limit=20;
  contentlist=[];
  isError=false;

  //pagination var
  pageSize = 20;
  currentPage = 0;
  totalSize = 0;
  start = 0;
  end = 20;
  pageEvent: any;
  totalrow: number;
  notfound = false;

  testSeriesbox: any;
  testPaperbox: any;
  testSeriesId = 0;
  testPaperId = 0;
  abc = '';
  additionalSearch:any = {};
  date = new FormControl(new Date());
  status1 = [
    {value: null, viewValue: '--Status--'},
    {value: 'Assigned', viewValue: 'Assigned'},
    {value: 'Completed', viewValue: 'Completed'}
  ];
  constructor(private commonService:commonService,private router:Router,private global : Globals,private TestSeriesService:TestSeriesService) {
    this.commonService.profile.subscribe((data:any)=>{
       if(data){
       this.userData=data; 
       }else{
         this.userData={};
       } 
     });
     this.path='';//this.global.objectStorage+this.global.profileFolder+'/';
   }

  ngOnInit() {
    this.totalrow = 0;
    this.getUserTimeline();
    this.getTestSeriesList();
    // set message
    if(localStorage.getItem('isSuccess')=="Yes"){
      this.isSuccess=true;
      this.msg =    localStorage.getItem('msg');
      localStorage.removeItem('isSuccess');
      localStorage.removeItem('msg');
    }
    
  }

  // paging handle
  handlePage(e: any) {
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.end = this.pageSize;
    this.start = this.currentPage * this.pageSize;
    this.getUserTimeline()
  }

  getUserTimeline(){
    let obj={}
    obj['offset']=  this.start;
    obj['limit']=this.end;
    obj['userId']=(this.userData.id)?this.userData.id:0;
    obj['status']=this.searchstatus;
    obj['search']=this.serchtext;
    obj['additionalSearch']=this.additionalSearch;

    this.TestSeriesService.getUserTimeline(obj).subscribe((data:any)=>{
          this.isPostLoad=false;
         if(data.error==0){
           this.totalrow = data.results.count;
          if(data.results.rows.length > 0){ 
            this.notfound = false;
            this.contentlist = data.results.rows;
            this.isPostLoad=false;
          }else{
            this.notfound = true;
            this.contentlist = [];
            this.isPostLoad=false;
          }
            
          }
          else{
            if(data.message=="Failed to authenticate token."){
              sessionStorage.clear();
              localStorage.clear();
              this.router.navigate(['/']);
            }else{
             this.msg = data.message;
             this.isError = true;
            }
          }
    },(error:HttpErrorResponse)=>{
     // this.msg="internal server error!";
    })
  }

  filterform(searchtxt){
    //console.log('dfffdfdf',searchtxt);
    this.additionalSearch.evaluateFrom=(searchtxt.value.evaluateFrom!='' && searchtxt.value.evaluateFrom!=null) ? this.newDt(searchtxt.value.evaluateFrom) : '0000-00-00';
    this.additionalSearch.evaluateTo=(searchtxt.value.evaluateTo!='' && searchtxt.value.evaluateTo!=null) ? this.newDt(searchtxt.value.evaluateTo) : '0000-00-00';
    
    this.additionalSearch.uploadFrom=(searchtxt.value.uploadFrom!='' && searchtxt.value.uploadFrom!=null) ? this.newDt(searchtxt.value.uploadFrom) : '0000-00-00';
    this.additionalSearch.uploadTo=(searchtxt.value.uploadTo!='' && searchtxt.value.uploadTo!=null) ? this.newDt(searchtxt.value.uploadTo) : '0000-00-00';
    
    this.additionalSearch.testPaperId=searchtxt.value.testPaperId;
    this.additionalSearch.testseries=searchtxt.value.testseries;
    
    if(searchtxt.value.status!='' || searchtxt.value.search!=''){

    this.searchstatus=searchtxt.value.status;
    this.serchtext=searchtxt.value.search;
   
    }
    else{
      this.searchstatus='';
      this.serchtext='';
    }
    this.contentlist=[];
    this.getUserTimeline();
  }

  newDt(dt){
    dt = new Date(dt);
    return new Date(dt.getTime() - (dt.getTimezoneOffset() * 60000 )).toISOString().split('T')[0];
    }
  reset1(searchForm:NgForm){
    searchForm.reset();
    this.getUserTimeline();
  }

  /***************** */
  getTestSeriesList() {
    var obj = {};
    obj['Stype'] = 'status';
    // obj['streamId'] = this.streamId;
    obj['facultyId'] = (this.userData.id) ? this.userData.id : 0;
    this.TestSeriesService.getFacultyReportmainstslist(obj).subscribe((data: any) => {
      if (data.error == 0) {
        this.testSeriesbox = data.results;
      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    },
      (error: HttpErrorResponse) => {
        this.isError = true;
        this.msg = "internal server error!";
      });

  }

  onTPChange() {
    //this.testSeriesId = event.target.value;
    this.gettestpaperdropdownlist();
  }

  gettestpaperdropdownlist() {
    var obj = {};
    obj['testSeriesId'] = this.testSeriesId;
    obj['facultyId'] = (this.userData.id) ? this.userData.id : 0;

    this.TestSeriesService.getFacultyReportTestpererlist(obj).subscribe((data: any) => {
      if (data.error == 0) {
        this.testPaperbox = data.results;
      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
      this.isPostLoad = false;
    },
      (error: HttpErrorResponse) => {
        this.isError = true;
        this.msg = "internal server error!";
        this.isPostLoad = false;
      });

  }

}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/timeline/timeline.component.ts